import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext({ lang: 'ko', setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('medi_lang') || 'ko');

  useEffect(() => {
    localStorage.setItem('medi_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l === 'en' ? 'en' : 'ko');

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

// 짧은 헬퍼 — t({ ko: '...', en: '...' }) 형태로 호출
export function useT() {
  const { lang } = useLang();
  return (obj) => (obj && obj[lang] !== undefined ? obj[lang] : (obj && obj.ko) || '');
}
